var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarbonBookOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 5H13V6H9.5V5ZM9.5 7.5H13V8.5H9.5V7.5ZM9.5 10H13V11H9.5V10ZM3 5H6.5V6H3V5ZM3 7.5H6.5V8.5H3V7.5ZM3 10H6.5V11H3V10Z",
    fill: "#E78C40"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 2.5H2C1.73478 2.5 1.48043 2.60536 1.29289 2.79289C1.10536 2.98043 1 3.23478 1 3.5V12.5C1 12.7652 1.10536 13.0196 1.29289 13.2071C1.48043 13.3946 1.73478 13.5 2 13.5H14C14.2652 13.5 14.5196 13.3946 14.7071 13.2071C14.8946 13.0196 15 12.7652 15 12.5V3.5C15 3.23478 14.8946 2.98043 14.7071 2.79289C14.5196 2.60536 14.2652 2.5 14 2.5ZM2 3.5H7.5V12.5H2V3.5ZM8.5 12.5V3.5H14V12.5H8.5Z",
    fill: "#E78C40"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarbonBookOrange);
export default __webpack_public_path__ + "static/media/carbonBookOrange.2254a018fb711d283b87ca7b53eebdaf.svg";
export { ForwardRef as ReactComponent };